// import components
import { IconButton, Tooltip, Typography } from '@mui/material';
import {
  StyledButtonBoxWrapper,
  StyledTenantFooterBox
} from './TenantFooterBar.styles';
import { StyledSmallerIcon } from '../Icon/Icon.styles';

// import hooks
import { useEffect, useState } from 'react';
import { useSessionStorage } from 'usehooks-ts';
import { t } from 'i18next';

// import types
import type { TenantFooterBarProps } from './TenantFooterBar.types';

const TenantFooterBar = ({ tenantName }: TenantFooterBarProps) => {
  'use memo';

  const [isHovered, setIsHovered] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  const [isTenantFooterHidden, setIsTenantFooterHidden] =
    useSessionStorage<boolean>('isTenantFooterHidden', false);

  const handleClose = () => {
    setIsHidden(true);
    setTimeout(() => {
      setIsTenantFooterHidden(true);
    }, 600);
  };

  // The close animation is local state, so when the flag is cleared elsewhere and the bar
  // comes back, the animation has to come back with it.
  useEffect(() => {
    if (!isTenantFooterHidden) {
      setIsHidden(false);
    }
  }, [isTenantFooterHidden]);

  if (isTenantFooterHidden || !tenantName) {
    return null;
  }

  return (
    <StyledTenantFooterBox
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      isHidden={isHidden}
    >
      <Typography
        variant="inherit"
        sx={{
          fontSize: (theme) => theme.typography.htmlFontSize,
          fontFamily: 'SourceSansPro-Bold'
        }}
      >
        {tenantName}
      </Typography>

      <StyledButtonBoxWrapper isHovered={isHovered}>
        <Tooltip title={`${t('hide')}`} arrow>
          <IconButton size="small" onClick={handleClose}>
            <StyledSmallerIcon type="xmark" color="inherit" />
          </IconButton>
        </Tooltip>
      </StyledButtonBoxWrapper>
    </StyledTenantFooterBox>
  );
};

export default TenantFooterBar;
